/**
 * YNS Study Space: "Your goal" + step-by-step roadmap at the top of Home (#ynsGoal).
 *
 * Three goals: Ace nursing school, Pass the NCLEX, New grad & ICU. The first pick comes from what they bought
 * (data-default, set in sections/education-hub-main.liquid); they can switch anytime (localStorage yns_goal).
 * Each step points to one product and shows: Done, Continue (in progress), Start, Up next, or See what's inside
 * (not owned yet; no prices). Steps can be ticked off by hand (yns_goal_done); lecture courses tick themselves
 * when every lecture is watched.
 *
 * Ownership comes from data-owned ("|handle|handle|" from snippets/yns-owned-products.liquid, tags included),
 * so it works even for books whose PDFs aren't hosted in the Study Space yet.
 */
(function () {
  'use strict';

  var H = {
    pink: 'the-pink-book-nclex-ngn-test-taking-strategy-guide',
    gold: 'nclex-content-review-guide-2026-gold-book-20-chapters-quick-reference-vault-instant-pdf',
    core: 'nclex-core-bundle',
    ft: 'nclex-fasttrack-bundle',
    klimek: 'marks-2026-nclex-review-mega-bundle-video-lectures-pdf-study-guides-professor-mark-johnsons-nclex-mega-bundle',
    qbank: 'nclex-question-bank-3000-nclex-rn-pn-practice-test-high-yield-qbank-with-rationales',
    mastery: '2026-nclex-ultimate-mastery-notes-nclex-high-yield-study-guide-with-mnemonics',
    crash: '2026-nclex-crash-course-notes-high-yield-study-guide-test-taking-strategies',
    pharm: 'pharmacology-study-guide-nclex-pharmacology-pages-2026-edition-nursing-ebook',
    ecg: 'ecg-dysrhythmia-interpretation-bundle-19100',
    cc: 'critical-care-nursing-medications-80511',
    icu: 'icu-survival-notes-the-ultimate-critical-care-nursing-guide'
  };
  var GOALS = [
    { id: 'school', label: 'Ace nursing school', icon: '&#127891;', title: 'Your nursing school roadmap' },
    { id: 'nclex', label: 'Pass the NCLEX', icon: '&#127942;', title: 'Your NCLEX roadmap' },
    { id: 'icu', label: 'New grad & ICU', icon: '&#129658;', title: 'Your new grad & ICU roadmap' }
  ];

  var el, owned = '|';
  function read(k, f) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : f; } catch (e) { return f; } }
  function write(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function has() { for (var i = 0; i < arguments.length; i++) if (owned.indexOf('|' + arguments[i] + '|') > -1) return true; return false; }
  function D() { return window.YNS_SECURE_DATA || { videos: [], pdfs: [] }; }
  function pdf(id) { return (D().pdfs || []).filter(function (p) { return p.legacyId === id && p.hasAccess; })[0] || null; }
  function pages() { return read('yns_pdf_last_page', {}); }
  function prog() { return read('yns_video_progress', {}); }
  function isDone(p) { return !!p && (p.completed || (p.progress || 0) >= 90); }
  function goTab(tab) { var b = document.querySelector('#desktopTabNav .yns-tab-btn[data-tab="' + tab + '"]'); if (b) b.click(); else location.hash = tab; }
  function examDays() {
    var d = read('yns_exam_date', null); if (!d) return null;
    var exam = new Date(d + 'T00:00:00'), now = new Date(); now.setHours(0, 0, 0, 0);
    return Math.round((exam - now) / 864e5);
  }
  function videosOf(test) { return (D().videos || []).filter(function (v) { return v.hasAccess && v.vimeoId && test(v); }); }

  // Step kinds: book (one PDF), course (lectures), tab (Q-Bank / plan), exam (countdown)
  function bookStep(key, title, product, handles, pdfId) {
    return { key: key, title: title, product: product, owned: has.apply(null, handles), url: '/products/' + handles[0], kind: 'book', pdfId: pdfId };
  }
  function steps(goal) {
    var ftPharm = has('ft-legacy-pharm');
    var gold = { key: 'gold', title: goal === 'school' ? 'Content by body system' : 'Build your content', product: 'Gold Book + lectures', owned: has(H.gold, H.core, H.ft) || videosOf(function (v) { return v.category === 'gold-book'; }).length > 0, url: '/products/' + H.core, kind: 'course', course: 'gold',
      note: goal === 'nclex' ? (has(H.klimek) ? 'Plus your Mark Klimek lectures' : 'Add-on: Mark Klimek lectures') : '', noteCourse: has(H.klimek) ? 'klimek' : null, noteUrl: has(H.klimek) ? null : '/products/' + H.klimek };
    var qbank = { key: 'qbank', title: 'Practice questions', product: 'NCLEX Q-Bank', owned: has(H.qbank, H.ft) || el.dataset.qbank === 'true', url: '/products/' + H.qbank, kind: 'tab', tab: 'qbank' };
    var pink = bookStep('pink', goal === 'school' ? 'Learn how to answer exam questions' : 'Learn the strategy', 'The Pink Book', [H.pink, H.core, H.ft], 'core-pink-book');
    var pharm = bookStep('pharm', goal === 'icu' ? 'Med refresher' : 'Pharmacology', 'Pharmacology Mastery Book', [H.pharm], 'pharmacology-notes');
    if (ftPharm) pharm.owned = true;
    var ecg = bookStep('ecg', goal === 'icu' ? 'Rhythms on the monitor' : 'ECG and rhythms', 'ECG & Dysrhythmia Interpretation', [H.ecg], 'ecg-bundle');
    var cc = bookStep('cc', 'Drips and critical meds', 'Critical Care Meds Flashcards', [H.cc], 'critical-care-flashcards');
    var icu = { key: 'icu', title: 'ICU foundations', product: 'ICU Survival Book + video lessons', owned: has(H.icu) || videosOf(function (v) { return v.category === 'icu'; }).length > 0, url: '/products/' + H.icu, kind: 'course', course: 'icu' };
    if (goal === 'school') return [pink, pharm, ecg, gold, qbank];
    if (goal === 'icu') return [icu, ecg, cc, pharm];
    return [pink, gold, qbank,
      bookStep('mastery', 'High-yield review', 'Ultimate Mastery Book', [H.mastery, H.ft], 'nclex-mastery-notes'),
      bookStep('crash', 'Last-minute review', '45-Minute Crash Course Book', [H.crash, H.ft], 'nclex-crash-course'),
      { key: 'exam', title: 'Exam day', product: has(H.ft) ? 'Your FastTrack exam plan' : 'Your countdown', owned: true, kind: 'exam' }];
  }

  // started / done for an owned step
  function stepState(s, manual) {
    if (s.kind === 'exam') { var d = examDays(); return { done: d !== null && d < 0, started: d !== null }; }
    if (manual[s.key]) return { done: true, started: true };
    if (s.kind === 'course') {
      var vs = videosOf(s.course === 'gold' ? function (v) { return v.category === 'gold-book'; } : function (v) { return v.category === 'icu'; });
      var p = prog(), n = vs.filter(function (v) { return isDone(p[v.id]); }).length, any = vs.some(function (v) { return p[v.id] && p[v.id].currentTime > 0; });
      return { done: vs.length > 0 && n === vs.length, started: n > 0 || any, detail: vs.length ? n + ' of ' + vs.length + ' lectures' : '' };
    }
    if (s.kind === 'book') { var b = pdf(s.pdfId), pg = b && pages()[b.id]; return { done: false, started: !!pg, detail: pg ? 'Page ' + pg : '' }; }
    return { done: false, started: false };
  }

  // Short label + one-line "why" for each stop on the road
  var INFO = {
    pink: ['Strategy', 'The Triple S method for breaking down any question and picking the safest answer.'],
    pharm: ['Pharmacology', 'Every drug class, side effect and nursing check you get tested on.'],
    ecg: ['Rhythms', 'Read the 27 rhythms you meet in class, clinicals and on the monitor.'],
    gold: ['Content', 'Content review by body system, with a lecture for every chapter.'],
    qbank: ['Practice', 'Questions with rationales, so you learn the why and not just the answer.'],
    mastery: ['Review', 'High-yield review of what shows up most, with mnemonics.'],
    crash: ['Crash course', 'A 45-minute last look at the must-knows before test day.'],
    exam: ['Exam day', 'Set your date and we count down with you.'],
    icu: ['ICU basics', 'Lines, vents, drips and your first six months, with video lessons.'],
    cc: ['Critical meds', 'The drips you titrate every shift, as quick flashcards.']
  };
  var last = null;
  window.YNSGoal = {
    summary: function () {
      if (!el) return null;
      if (!last) render();
      var L = last.list, f = last.focus, gap = L.filter(function (s) { return !s.owned && s.kind !== 'exam'; })[0] || null;
      return { total: L.length, focusIndex: Math.max(f, 0), focus: f >= 0 ? L[f] : null, gap: gap, hasPractice: L.some(function (s) { return s.key === 'qbank' && s.owned; }) || el.dataset.qbank === 'true' };
    },
    openFocus: function () {
      var s = last && last.focus >= 0 ? last.list[last.focus] : null;
      if (!s) return;
      if (!s.owned && s.url) { location.href = s.url; return; }
      openStep(s);
    }
  };
  var FINISH = { school: 'Graduate', nclex: 'RN', icu: 'Shift ready' };
  var selected = null;

  function statusOf(s, st, i, focus, manual) {
    if (s.kind === 'exam') {
      var d = examDays();
      return { text: d === null ? 'Set your exam date' : d < 0 ? 'Done' : d === 0 ? 'Today. You\'ve got this.' : d + (d === 1 ? ' day to go' : ' days to go'),
        act: has(H.ft) ? '<button type="button" class="ygl-act ygl-act--main" data-ygl="tab" data-tab="fasttrack">Open my exam plan</button>' : '<button type="button" class="ygl-act ygl-act--main" data-ygl="date">' + (d === null ? 'Set my exam date' : 'Change date') + '</button>' };
    }
    if (!s.owned) return { text: i === focus ? 'Up next' : 'Not in your plan yet', act: '<a class="ygl-act" href="' + esc(s.url) + '">See what\'s inside</a>' };
    if (st.done) return { text: 'Done', act: '<button type="button" class="ygl-act" data-ygl="open" data-i="' + i + '">Review</button>' };
    return { text: st.started ? (st.detail || 'In progress') : (i === focus ? 'Up next' : 'Ready when you are'),
      act: '<button type="button" class="ygl-act ygl-act--main" data-ygl="open" data-i="' + i + '">' + (st.started ? 'Continue' : 'Start') + ' <span aria-hidden="true">&rarr;</span></button>' };
  }

  // The road: stops on a gentle S-curve climbing to the finish flag
  function road(list, states, focus, sel, goal) {
    var n = list.length + 1, W = 1000, pts = [];
    var ys = [235, 150, 205, 110, 175, 85, 140];
    for (var i = 0; i < n; i++) pts.push([70 + i * (W - 140) / (n - 1), i === n - 1 ? 60 : ys[i % ys.length]]);
    function seg(a, b) { var mx = (a[0] + b[0]) / 2; return ' C' + mx + ' ' + a[1] + ' ' + mx + ' ' + b[1] + ' ' + b[0] + ' ' + b[1]; }
    var full = 'M' + pts[0][0] + ' ' + pts[0][1], done = full;
    for (var j = 1; j < n; j++) { full += seg(pts[j - 1], pts[j]); if (j <= Math.max(focus, 0)) done += seg(pts[j - 1], pts[j]); }
    if (focus < 0) done = full;
    var svg = '<svg class="ygl-road__svg" viewBox="0 0 ' + W + ' 300" role="group" aria-label="Your road, ' + list.length + ' stops">' +
      '<path d="' + full + '" class="ygl-road__base"/><path d="' + full + '" class="ygl-road__dash"/>' + (focus !== 0 ? '<path d="' + done + '" class="ygl-road__done"/>' : '');
    list.forEach(function (s, k) {
      var p = pts[k], st = states[k], cls = st.done ? 'is-done' : k === focus ? 'is-here' : !s.owned ? 'is-locked' : 'is-open';
      if (k === sel) cls += ' is-sel';
      var lab = INFO[s.key] ? INFO[s.key][0] : s.title;
      svg += '<g class="ygl-stop ' + cls + '" data-ygl="sel" data-i="' + k + '" role="button" tabindex="0" aria-label="Stop ' + (k + 1) + ': ' + esc(s.title) + '">' +
        '<circle class="ygl-stop__hit" cx="' + p[0] + '" cy="' + p[1] + '" r="34"/>' +
        '<circle class="ygl-stop__dot" cx="' + p[0] + '" cy="' + p[1] + '" r="' + (k === focus ? 26 : 21) + '"/>' +
        '<text class="ygl-stop__n" x="' + p[0] + '" y="' + (p[1] + 7) + '">' + (st.done ? '✓' : !s.owned ? '🔒︎' : (k + 1)) + '</text>' +
        '<text class="ygl-stop__lab" x="' + p[0] + '" y="' + (p[1] + (k === focus ? 58 : 50)) + '">' + esc(lab) + '</text></g>';
    });
    var f = pts[n - 1];
    svg += '<g class="ygl-finish"><path d="M' + f[0] + ' ' + (f[1] + 22) + 'V' + (f[1] - 26) + '" /><path class="ygl-finish__flag" d="M' + f[0] + ' ' + (f[1] - 26) + 'h34l-9 10 9 10h-34z"/>' +
      '<text class="ygl-stop__lab" x="' + f[0] + '" y="' + (f[1] + 56) + '">' + FINISH[goal] + '</text></g>';
    if (focus >= 0) {
      var m = pts[focus];
      svg += '<image class="ygl-mascot" href="' + esc(el.dataset.mascot || '') + '" x="' + (m[0] - 38) + '" y="' + (m[1] - 112) + '" width="76" height="76"/>' +
        '<text class="ygl-here" x="' + m[0] + '" y="' + (m[1] - 120) + '">You are here</text>';
    }
    return svg + '</svg>';
  }

  function render() {
    var goal = read('yns_goal', null) || el.dataset.default || 'nclex'; // set in the welcome flow (assets/yns-welcome.js), else from purchases
    if (!GOALS.some(function (g) { return g.id === goal; })) goal = 'nclex';
    var picked = true, manual = read('yns_goal_done', {});
    var list = steps(goal), G = GOALS.filter(function (g) { return g.id === goal; })[0];
    var hub = document.getElementById('ynsEducationHub'); if (hub) hub.dataset.goal = goal; // per-goal color scheme
    var states = list.map(function (s) { return s.owned ? stepState(s, manual) : { done: false, started: false }; });
    var doneN = states.filter(function (x) { return x.done; }).length, focus = -1;
    list.forEach(function (s, i) { if (focus < 0 && !states[i].done) focus = i; });
    var sel = selected !== null && selected < list.length ? selected : Math.max(focus, 0);

    var s = list[sel], st = states[sel], ss = statusOf(s, st, sel, focus, manual);
    var tick = s.owned && s.kind !== 'exam' && s.kind !== 'course'
      ? '<button type="button" class="ygl-tick" data-ygl="tick" data-key="' + s.key + '" aria-pressed="' + !!manual[s.key] + '">' + (manual[s.key] ? '&#10003; Marked done' : 'Mark as done') + '</button>' : '';
    var note = s.note ? '<p class="ygl-detail__note">' + (s.noteCourse ? '<button type="button" data-ygl="course" data-c="' + s.noteCourse + '">' + esc(s.note) + ' &rarr;</button>' : '<a href="' + esc(s.noteUrl) + '">' + esc(s.note) + ' &rarr;</a>') + '</p>' : '';
    var detail = '<div class="ygl-detail' + (sel === focus ? ' is-here' : '') + '">' +
      '<div class="ygl-detail__txt"><p class="ygl-detail__kick">Stop ' + (sel + 1) + ' of ' + list.length + ' · <span class="ygl-detail__status">' + esc(ss.text) + '</span></p>' +
      '<h3>' + esc(s.title) + '</h3><p class="ygl-detail__prod">' + esc(s.product) + '</p>' +
      '<p class="ygl-detail__why">' + esc(INFO[s.key] ? INFO[s.key][1] : '') + '</p>' + note + '</div>' +
      '<div class="ygl-detail__acts">' + ss.act + tick + '</div></div>';

    var phoneList = '<ol class="ygl-steps" role="list">' + list.map(function (x, i) {
      var y = states[i], z = statusOf(x, y, i, focus, manual);
      // phones: the action is a round arrow on the right; the whole row is tappable
      var arrow = z.act.replace(/^<(button|a)([^>]*)class="ygl-act[^"]*"([^>]*)>([\s\S]*?)<\/\1>/, function (m, tag, a1, a2, label) {
        var txt = label.replace(/<[^>]+>/g, '').replace(/&rarr;/g, '').trim();
        return '<' + tag + a1 + 'class="ygl-act ygl-act--arrow"' + a2 + ' aria-label="' + esc(txt) + ': ' + esc(x.title) + '"><span aria-hidden="true">&rarr;</span></' + tag + '>';
      });
      return '<li data-ygl="row" class="ygl-step' + (y.done ? ' is-done' : '') + (i === focus ? ' is-focus' : '') + (!x.owned ? ' is-locked' : '') + '"><span class="ygl-step__n" aria-hidden="true">' + (y.done ? '&#10003;' : !x.owned ? '&#128274;&#xFE0E;' : (i + 1)) + '</span>' +
        '<span class="ygl-step__txt"><b>' + esc(x.title) + '</b><small>' + esc(x.product) + ' · <span class="ygl-step__status">' + esc(z.text) + '</span></small></span><span class="ygl-step__acts">' + arrow + '</span></li>';
    }).join('') + '</ol>';

    el.innerHTML =
      '<section class="ygl-map" aria-labelledby="yglTitle">' +
        '<div class="ygl-map__head"><div><h2 id="yglTitle">' + esc(G.title) + '</h2><p class="ygl-map__sub">' + doneN + ' of ' + list.length + ' stops done' + (picked ? '' : ' · picked from what you own') + '</p></div>' +
        '<div class="ygl-goals" role="radiogroup" aria-label="Your goal">' + GOALS.map(function (g) {
          return '<button type="button" role="radio" class="ygl-goal' + (g.id === goal ? ' is-on' : '') + '" aria-checked="' + (g.id === goal) + '" data-ygl="goal" data-g="' + g.id + '">' + esc(g.label) + '</button>';
        }).join('') + '</div></div>' +
        '<div class="ygl-road">' + road(list, states, focus, sel, goal) + '</div>' + phoneList + detail +
      '</section>';
    el._steps = list;
    last = { list: list, states: states, focus: focus };
    renderLevel(goal, doneN, list.length);
  }

  // Sidebar level card + goal label (one place for "how far along am I")
  var RANKS = { school: ['Getting started', 'Finding your rhythm', 'Building confidence', 'Almost there', 'Ready to graduate'],
    nclex: ['Getting started', 'Rookie', 'Rising RN', 'Strong contender', 'Exam ready'],
    icu: ['Getting started', 'Learning the unit', 'Finding your feet', 'Almost there', 'Shift ready'] };
  function renderLevel(goal, done, total) {
    var lab = document.getElementById('yhubGoalLabel'), lv = document.getElementById('yhubLevel');
    var G = GOALS.filter(function (x) { return x.id === goal; })[0];
    if (lab && G) lab.textContent = G.label;
    if (!lv) return;
    var r = RANKS[goal] || RANKS.nclex, idx = done >= total ? r.length - 1 : Math.min(r.length - 2, Math.floor(done / total * (r.length - 1)));
    lv.innerHTML = '<div class="yhub-level__top"><span class="yhub-level__badge">Lv ' + done + '</span><span class="yhub-level__rank">' + esc(r[idx]) + '</span></div>' +
      '<div class="yhub-level__bar" role="progressbar" aria-valuemin="0" aria-valuemax="' + total + '" aria-valuenow="' + done + '" aria-label="Stops done"><span style="width:' + Math.round(done / total * 100) + '%"></span></div>' +
      '<p class="yhub-level__meta">' + done + ' of ' + total + ' stops on your road</p>';
  }

  function openStep(s) {
    if (!s) return;
    if (s.kind === 'course' && window.YNSOpenCourse) return window.YNSOpenCourse(s.course);
    if (s.kind === 'tab') return goTab(s.tab);
    if (s.kind === 'book') {
      var b = pdf(s.pdfId);
      if (b && window.YNSOpenBook) return window.YNSOpenBook(b.id);
      if (s.key === 'mastery' && window.YNSOpenCourse) return window.YNSOpenCourse('mastery');
      return goTab('library');
    }
  }
  function onClick(e) {
    var b = e.target.closest('[data-ygl]'); if (!b || !el.contains(b)) return;
    var a = b.dataset.ygl;
    if (a === 'goal') { write('yns_goal', b.dataset.g); selected = null; render(); window.dispatchEvent(new CustomEvent('yns:goal')); }
    else if (a === 'row') { if (e.target.closest('a, button')) return; var x = b.querySelector('.ygl-act'); if (x) x.click(); }
    else if (a === 'sel') { selected = +b.dataset.i; render(); }
    else if (a === 'open') openStep(el._steps[+b.dataset.i]);
    else if (a === 'course' && window.YNSOpenCourse) window.YNSOpenCourse(b.dataset.c);
    else if (a === 'tab') goTab(b.dataset.tab);
    else if (a === 'tick') { var m = read('yns_goal_done', {}); if (m[b.dataset.key]) delete m[b.dataset.key]; else m[b.dataset.key] = true; write('yns_goal_done', m); render(); }
    else if (a === 'date') { var inp = document.querySelector('#ynsExamSlot input[type="date"], #ynsToday input[type="date"]'); if (inp) { inp.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { inp.focus(); }, 300); } }
  }

  function init() {
    el = document.getElementById('ynsGoal');
    if (!el) return;
    owned = el.dataset.owned || '|';
    el.addEventListener('click', onClick);
    window.addEventListener('yns:goal', function () { selected = null; render(); });
    el.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target.closest('[data-ygl="sel"]')) { e.preventDefault(); onClick(e); } });
    render();
    window.addEventListener('hashchange', function () { if (location.hash === '#today') render(); });
    var today = document.getElementById('ynsToday'); // exam date saved on the Today card: refresh the countdown step
    if (today) today.addEventListener('click', function () { setTimeout(render, 120); });
    var exam = document.getElementById('ynsExamSlot');
    if (exam) exam.addEventListener('click', function () { setTimeout(render, 120); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
